import React from 'react';
import ReactDOM from 'react-dom';
import App from '../components/App';

export const bootstrap = () => {
  ReactDOM.render(
    React.createElement(App),
    document.getElementById('react-root'),
  );
};
